import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class FilterService {

	itemNotInSelection(list, list_selection, argument) {
		var returnData = [];
		if (list_selection && list_selection.length > 0) {
			for (let item of list) {
				var copy = true
				var a = item[argument];
				for (let sel of list_selection) {
					var b = sel[argument];
					if (a == b) {
						copy = false
					}
				}
				if (copy) {
					returnData.push(item)
				}
			}
			return returnData
		} else {
			return list
		}

	}
	argumentInList(list, list_id, argument) {
		var returnData = [];
		if (argument) {
			for (let item of list) {
				var a = item[list_id];
				if (a) {
					returnData.push(item)
				}
			}
			return returnData
		} else {
			return list
		}

	}
	ElementInList(list, list_id, elements_id) {
		var returnData = [];
		if (list && elements_id) {
			for (let item of list) {
				var copyItem = false;
				var a = item[list_id];
				if (a) {
					if (a.toString() == elements_id.toString()) {
						returnData.push(item)
					}
				}


			}

		} else {
			return list
		}
		return returnData
	}
	ElementInListElements(list, list_id, elements, elements_id) {
		var returnData = [];
		if (list && (elements && elements.length > 0)) {
			for (let item of list) {
				var copyItem = false;
				var a = item[list_id];
				for (let obj of elements) {
					var b = obj[elements_id];
					if (a && b && a.toString() == b.toString()) {
						returnData.push(item)
					}
				}
			}

		} else {
			return list
		}
		return returnData
	}

	ElementInListElementsExcludeOption(list, list_id, elements, elements_id) {
		elements = elements ? elements : [];
		let newList = JSON.parse(JSON.stringify(list));
		let excludedElements = elements.filter(el => el.isExcluded);
		let notExcludedElements = elements.filter(el => !el.isExcluded);

		if (list && (elements && elements.length > 0)) {

			// Removes elements mark as "Excluded"
			if (excludedElements.length) {
				newList = newList.filter(item => {
					let exists = excludedElements.find(element => element[elements_id] == item[list_id]);
					return exists ? false : true;
				});
			}

			// Keeps elements that are not marked as "excluded"
			if (notExcludedElements.length) {
				newList = newList.filter(item => {
					let exists = notExcludedElements.find(element => element[elements_id] == item[list_id]);
					return exists ? true : false;
				});
			}

		} else {
			return list;
		}
		return newList;
	}

	ElementInListElementsSplitExcludeOption(list, list_id, elements, elements_id, splitCharacter = ',') {
		elements = elements ? elements : [];
		let newList = JSON.parse(JSON.stringify(list));
		let excludedElements = elements.filter(el => el.isExcluded);
		let notExcludedElements = elements.filter(el => !el.isExcluded);

		if (list && (elements && elements.length > 0)) {

			// Removes elements mark as "Excluded"
			if (excludedElements.length) {
				newList = newList.filter(item => {
					let exists = excludedElements.find(element => {
						if (!item[list_id]) return false;
						let splitList = item[list_id].split(splitCharacter);
						return splitList.find(i => element[elements_id] == i);
					});
					return exists ? false : true;
				});
			}

			// Keeps elements that are not marked as "excluded"
			if (notExcludedElements.length) {
				newList = newList.filter(item => {
					let exists = notExcludedElements.find(element => {
						if (!item[list_id]) return false;
						let splitList = item[list_id].split(splitCharacter);
						return splitList.find(i => element[elements_id] == i);
					});
					return exists ? true : false;
				});
			}

		} else {
			return list;
		}
		return newList;
	}

	ElementInListElementsSplit(list, list_id, elements, elements_id) {
		var returnData = [];
		if (elements && elements.length > 0) {
			for (let item of list) {
				var copyItem = false;
				var a = item[list_id];
				if (a) {
					var b = a.split(',')
					for (let obj of b) {
						for (let elm of elements) {
							var elemdata = elm[elements_id];
							if (obj == elemdata) {
								copyItem = true;
							}
						}
					}
				}
				if (copyItem) {
					returnData.push(item);
				}
			}
		} else {
			return list
		}
		return returnData
	}

	ElementInElementsSplit(list, list_id, elements_id) {
		var returnData = [];
		if (list && elements_id) {
			for (let item of list) {
				var copyItem = false;
				var a = item[list_id];
				if (a) {
					var c = a.split(',')
					for (let pp of c) {
						if (pp && pp.toString() == elements_id.toString()) {
							returnData.push(item)
						}

					}
				}
			}

		} else {
			return list
		}
		return returnData
	}
	fromToNumber(list, list_id, from, to) {
		var returnData = [];
		if (from || to) {
			for (let item of list) {
				var a = item[list_id];
				if (!to) {
					if (Number(a) >= Number(from)) {
						returnData.push(item)
					}
				} else if (!from) {
					if (Number(a) <= Number(to)) {
						returnData.push(item)
					}
				} else {
					if (Number(a) >= Number(from) && Number(a) <= Number(to)) {
						returnData.push(item)
					}
				}
			}
			return returnData
		} else {
			return list
		}
	}
	fromToDate(list, list_id, from_arg, to_arg) {
		var returnData = [];
		if (from_arg || to_arg) {
			var from = new Date(from_arg)
			var to = new Date(to_arg)
			for (let item of list) {
				var a = item[list_id];
				a = new Date(a)
				if (!to_arg) {
					if (a >= from) {
						returnData.push(item)
					}
				} else if (!from_arg) {
					if (a <= to) {
						returnData.push(item)
					}
				} else {
					if (a >= from && a <= to) {
						returnData.push(item)
					}
				}
			}
			return returnData
		} else {
			return list
		}
	}

	filterDateRange(list, value, from, to) {
		var returnlist = [];
		if (from || to) {
			const FROM_DATE = this._dP.transform(from, 'yyyy-MM-dd')
			const TO_DATE = this._dP.transform(to, 'yyyy-MM-dd')
			for (let item of list) {
				var dateToCheck = item[value];
				if (dateToCheck) {
					var returnThis = false;
					var dateCheck = this._dP.transform(dateToCheck, 'yyyy-MM-dd')
					if (FROM_DATE && TO_DATE) {
						if (dateCheck >= FROM_DATE && dateCheck <= TO_DATE) {
							returnThis = true;
						}
					} else if (FROM_DATE) {
						if (dateCheck >= FROM_DATE) {
							returnThis = true;
						}
					} else if (TO_DATE) {
						if (dateCheck <= TO_DATE) {
							returnThis = true;
						}
					}
					if (returnThis) {
						returnlist.push(item)
					}
				}
			}
		} else {
			returnlist = list;
		}
		return returnlist;
	}

	generalPlanElementCategories(list, elements) {
		var returnData = [];
		if (elements && elements.length > 0) {
			for (let item of list) {
				if (item.all_element_categories_ids) {
					for (let id of item.all_element_categories_ids.split(',')) {
						for (let elm of elements) {
							if (id.toString() === elm.id.toString()) {
								returnData.push(item)
							}
						}

					}
				}
			}
			return returnData
		} else {
			return list
		}
	}
	generalPlanElements(list, elements) {
		var returnData = [];
		if (elements && elements.length > 0) {
			for (let item of list) {
				if (item.all_elements_ids) {
					for (let id of item.all_elements_ids.split(',')) {
						for (let elm of elements) {
							if (id.toString() === elm.id.toString()) {
								returnData.push(item)
							}
						}

					}
				}
			}
			return returnData
		} else {
			return list
		}
	}
	generalPlanEvents(list, elements) {
		var returnData = [];
		if (elements && elements.length > 0) {
			for (let item of list) {
				if (item.all_events_ids) {
					for (let id of item.all_events_ids.split(',')) {
						for (let elm of elements) {
							if (id.toString() === elm.id.toString()) {
								returnData.push(item)
							}
						}

					}
				}
			}
			return returnData
		} else {
			return list
		}
	}
	generalPlanEventTypes(list, elements) {
		var returnData = [];
		if (elements && elements.length > 0) {
			for (let item of list) {
				if (item.all_event_type_ids) {
					for (let id of item.all_event_type_ids.split(',')) {
						for (let elm of elements) {
							if (id.toString() === elm.id.toString()) {
								returnData.push(item)
							}
						}
					}
				}
			}
			return returnData
		} else {
			return list
		}
	}

	generalPlanCharacters(list, filter_characters, only, atleast) {
		var returnData = [];
		if (filter_characters && filter_characters.length > 0) {
			for (let item of list) {
				var has_one_character = false
				var has_all_characters = true
				if (item.all_character_ids) {
					for (let fc of filter_characters) {
						var is_this_character = false
						for (let id of item.all_character_ids.split(',')) {
							if (id.toString() === fc.id.toString()) {
								is_this_character = true
							}
						}
						if (is_this_character) {
							has_one_character = true
						} else {
							has_all_characters = false
						}
					}
				}
				if (has_one_character) {
					if (only && !atleast) {
						if (item.all_character_ids.split(',').length === filter_characters.length && has_all_characters) {
							returnData.push(item)
						}
					}
					if (atleast && !only) {
						returnData.push(item)
					}
					if (!atleast && !only) {
						if (has_one_character && has_all_characters) {
							returnData.push(item)
						}
					}
				}
			}
			return returnData
		} else {
			return list
		}
	}

	/**
	* @param {Object[]} list array de objetos a organizar
	* @param {string} property
	* @param {string} sortingType  Tipo del sort: DESC o ''
	*/
	sortByArgument(list: any[], property: string, orderBy: string) {
		if (!orderBy) return list;
		let sortOrder = 1;
		if (orderBy.indexOf('DESC') > -1) {
			sortOrder = -1;
		}
		return list.sort((a, b) => {
			return this.doValidatedSort(a, b, property, sortOrder);
		})
	}

	sortByMultiplesArguments(list, orderBy) {
		let that = this;
		return list.sort(
			(a, b) => {
				return orderBy
					.map((o) => {
						let sortOrder = 1;
						let property = JSON.parse(JSON.stringify(o)).replace(" DESC", "");
						if (o.indexOf('DESC') > -1) {
							sortOrder = -1;
						}
						return that.doValidatedSort(a, b, property, sortOrder);
					})
					.reduce((p, n) => {
						return p ? p : n;
					}, 0);
			}
		);
	}

	doValidatedSort(a: any, b: any, property: string, sortOrder: number) {
		if (a[property] === null || a[property] === undefined || a[property] === false) {
			return 1 * sortOrder;
		}
		if (b[property] === null || b[property] === undefined || b[property] === false) {
			return -1 * sortOrder;
		}
		let result = `${this.normalizeString(a[property])}`.localeCompare(`${this.normalizeString(b[property])}`, undefined, {
			numeric: true,
			sensitivity: 'base'
		});

		return result * sortOrder;
	}

	filterByArgument(list, argument, value) {
		if ((value || value == 0) && value != "") {
			return list.filter(element => {
				var a = element[argument];
				return a == value;
			});

		} else {
			return list;
		}
	}

	filterByTrueFalse(list, argument, value) {
		return list.filter(element => {
			var a = element[argument];
			return a == value;
		});
	}

	searchByMultipleValues(list: any[], properties: string[], textToSearch: string): any[] {
		var returnList = [];
		if (textToSearch) {
			returnList = list.filter(element => {
				var aev = this.normalizeString(textToSearch.toLowerCase());
				var retItem = false;
				for (let item of properties) {
					var text = element[item];
					if (text) {
						text = text.toString()
						var a = this.normalizeString(text.toLowerCase());
						if (a.indexOf(aev) > -1) {
							retItem = true;
						}
					}

				}
				return retItem;
			});

		} else {
			returnList = list
		}
		return returnList;
	}

	searchByMultipleValuesExtended(list: any[], properties: any[], textToSearch: string): any[] {
		var returnList = [];
		if (textToSearch) {
			returnList = list.filter(element => {
				var aev = this.normalizeString(textToSearch.toLowerCase());
				var retItem = false;
				for (let item of properties) {
					if (typeof item === 'string') {
						var text = element[item];
						if (text) {
							text = text.toString()
							var a = this.normalizeString(text.toLowerCase());
							if (a.indexOf(aev) > -1) {
								retItem = true;
							}
						}
					} else { // Object {'children' and 'property'}
						if (element[item.children]) {
							for (const el of element[item.children]) {
								var text = el[item.property];
								if (text) {
									text = text.toString()
									var a = this.normalizeString(text.toLowerCase());
									if (a.indexOf(aev) > -1) {
										retItem = true;
									}
								}
							}
						}
					}

				}
				return retItem;
			});

		} else {
			returnList = list
		}
		return returnList;
	}

	normalizeString(text) {
		return `${text}`.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
	}

	filterExcludedElements(elements, list, id = 'id'): any[] {

		let excludedElements = elements.filter(el => el.isExcluded);
		let notExcludedElements = elements.filter(el => !el.isExcluded);
		let filteredList = JSON.parse(JSON.stringify(list));

		if (elements.length) {
			//Removes excluded elements
			if (excludedElements.length) {
				filteredList = list.filter(item => {
					let exists = excludedElements.find(elem => elem[id] == item[id]);
					return exists ? false : true;
				})
			}
			//Keeps only elements that are not excluded
			if (notExcludedElements.length) {
				filteredList = filteredList.filter(item => {
					let exists = notExcludedElements.find(elem => elem[id] == item[id]);
					return exists ? true : false;
				});
			};
		} else {
			return elements;
		}
		return filteredList;
	}

	validateTablefieldsFilter(tableFields, filters) {
		for (const field of tableFields) {
			this.updateValidationFieldFilter(field, filters);
		}
	}

	updateValidationFieldFilter(field, filters) {
		switch (field.value) {
			case 'invoice_date':
			case 'created_at':
			case 'date_submited':
			case 'date_approved':
			case 'date_reviewed_finaces':
			case 'date_legalized':
			case 'date_rejected':
			case 'total_invoices':
			case 'cost':
			case 'total_cost':
				field.isFilterActive = filters[`${field.value}_from`] || filters[`${field.value}_to`] ? true : false;
				return;
		}
		if (field.value.includes('value_tax')) {
			field.isFilterActive = filters[`${field.value}_from`] || filters[`${field.value}_to`] ? true : false;
			return;
		}
		field.isFilterActive = this.checkMultipleSelectActive(filters, field);
		return;

	}

	checkMultipleSelectActive(filters, field) {
		return filters[field.value] ? (filters[field.value].length ? true : false) : false;
	}

	filterRange(list, value, from, to) {
		var returnlist = [];
		if (from || to) {
			for (let item of list) {
				var returnThis = false;
				if (from && to) {
					if (parseFloat(item[value]) >= parseFloat(from) && parseFloat(item[value]) <= parseFloat(to)) {
						returnThis = true;
					}
				} else if (from) {
					if (parseFloat(item[value]) >= parseFloat(from)) {
						returnThis = true;
					}
				} else if (to) {
					parseFloat(item[value])
					if (parseFloat(item[value]) <= parseFloat(to)) {
						returnThis = true;
					}
				}
				if (returnThis) {
					returnlist.push(item)
				}
			}
		} else {
			returnlist = list;
		}
		return returnlist;
	}

	filterArrayByArray(list, parameterList, filterList, filterParameter) {
		let ids = filterList.map((fl: any) => fl[filterParameter]);
		return list.filter((elemento) => ids.includes(elemento[parameterList]));
	}

	filterInMultipleSelectWithArray(list: any[], property: string, filter: any[], filter_property: string) {
		if (list) {
			let filteredList = list.filter(item => {
				for (const element of filter) {
					if (typeof element[filter_property] === 'string' && typeof item[property] === 'string') {
						if (element[filter_property].toUpperCase() == item[property].toUpperCase()) {
							return item;
						}
					} else if (element[filter_property] == item[property]) {
						return item;
					}
				}
			})
			return filteredList;
		}
		return list;
	}

	constructor(private _dP: DatePipe) { }
}
